import { useEffect, useState } from "react";
import { NavLink, useSearchParams } from "react-router-dom";
import { loadScript } from "../../../../../globals/constants";
import { jobService } from "../../../../../services/job-service";
import { formatDate } from "../../../admin/components/admin-ui";
import SectionBlogsSidebar from "../../sections/blogs/sidebar/section-blogs-sidebar";

function BlogListPage() {
    const [blogs, setBlogs] = useState([]);
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);

    const search = searchParams.get("search") || "";
    const categoryId = searchParams.get("category") || "";

    useEffect(() => {
        loadScript("js/custom.js");
    }, []);

    useEffect(() => {
        setLoading(true);
        jobService.blogs({ search, categoryId })
            .then((res) => {
                setBlogs(res.blogs || []);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }, [search, categoryId]);

    return (
        <div className="section-full p-t120 p-b90 site-bg-white">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-md-12">
                        {loading ? (
                            <div className="text-center p-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2 text-muted">Loading articles...</p>
                            </div>
                        ) : blogs.length === 0 ? (
                            <div className="text-center p-5 border rounded bg-light">
                                <i className="fa fa-newspaper fa-3x text-muted mb-3" />
                                <h3>No Articles Found</h3>
                                <p className="text-muted">Try adjusting your filters or search terms.</p>
                            </div>
                        ) : (
                            blogs.map((blog) => (
                                <div className="blog-post twm-blog-post-1-outer twm-blog-list-style shadow-sm border rounded p-3 mb-4 bg-white" key={blog.id}>
                                    <div className="wt-post-media" style={{ maxHeight: "300px", overflow: "hidden", borderRadius: "8px" }}>
                                        <NavLink to={`/blog-detail/${blog.id}`}>
                                            {blog.featured_image_url ? (
                                                <img src={blog.featured_image_url} alt={blog.title} style={{ width: "100%", height: "280px", objectFit: "cover" }} />
                                            ) : (
                                                <div className="bg-light d-flex align-items-center justify-content-center" style={{ width: "100%", height: "280px" }}>
                                                    <i className="fa fa-image fa-4x text-muted" />
                                                </div>
                                            )}
                                        </NavLink>
                                    </div>
                                    <div className="wt-post-info pt-3">
                                        <div className="wt-post-meta d-flex gap-3 text-muted mb-2" style={{ fontSize: "13px" }}>
                                            <span><i className="fa fa-calendar-alt me-1 text-primary" />{formatDate(blog.created_at)}</span>
                                            <span><i className="fa fa-user me-1 text-primary" />By {blog.author_name || "Admin"}</span>
                                            <span><i className="fa fa-clock me-1 text-primary" />{blog.read_time ? `${blog.read_time} min read` : "1 min read"}</span>
                                            <span><i className="fa fa-eye me-1 text-primary" />{blog.views || 0} views</span>
                                        </div>
                                        <div className="wt-post-title mb-2">
                                            <h4 className="post-title m-0">
                                                <NavLink to={`/blog-detail/${blog.id}`} className="text-dark hover-primary">{blog.title}</NavLink>
                                            </h4>
                                        </div>
                                        <div className="wt-post-text text-muted mb-3" style={{ fontSize: "14px", lineHeight: "1.6" }}>
                                            {blog.seo_description || blog.description?.replace(/<[^>]*>/g, "").substring(0, 160) + "..."}
                                        </div>
                                        <div className="wt-post-readmore d-flex justify-content-between align-items-center">
                                            <NavLink to={`/blog-detail/${blog.id}`} className="btn btn-primary btn-sm">
                                                Read More <i className="fa fa-angle-right ms-1" />
                                            </NavLink>
                                            {blog.category_name && (
                                                <span className="badge bg-light text-primary border">{blog.category_name}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                    <div className="col-lg-4 col-md-12 rightSidebar">
                        <SectionBlogsSidebar />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BlogListPage;